<template>
  <a-layout id="loginWarp">
    <!-- 美化弹窗组件 -->
    <BeautyModal
      :visible="modalVisible"
      :type="modalType"
      :title="modalTitle"
      :message="modalMessage"
      :extraInfo="modalExtraInfo"
      :confirmText="modalConfirmText"
      @confirm="handleModalConfirm"
      @close="handleModalClose"
    />
    <a-layout-header>
      <PageNav></PageNav>
    </a-layout-header>
    <a-layout-content class="loginBody">
      <div class="loginRight">
                        <h1>{{ $t('login.welcome_back') }}</h1>
        <a-tabs default-active-key="2" @change="onTabChange">
                      <a-tab-pane key="2" :title="$t('login.email_login')">
            <!-- 邮箱输入区域容器 -->
            <div class="email-section">
              <div class="email-container">
                <!-- 邮箱账号输入 -->
                <div class="label email-label">
                  <div class="label-header">
                    <icon-email class="label-icon"/>
                    <p class="label-text">{{ $t('login.email') }}</p>
                  </div>
                  <div class="input-wrapper">
                    <a-input 
                      class="input email-input" 
                      v-model="email" 
                      :placeholder="$t('login.enter_email')" 
                      @change="checkEmail"
                      @focus="onEmailFocus"
                      @blur="onEmailBlur">
                      <template #prefix>
                        <icon-email class="input-prefix-icon"/>
                      </template>
                    </a-input>
                    <div class="input-status" :class="{ 'show': email, 'valid': email && !is_email, 'invalid': email && is_email }">
                      <icon-check-circle v-if="email && !is_email" class="status-icon valid"/>
                      <icon-close-circle v-if="email && is_email" class="status-icon invalid"/>
                                          <span v-if="email && !is_email" class="status-text valid">{{ $t('login.email_format_correct') }}</span>
                    <span v-if="email && is_email" class="status-text invalid">{{ $t('login.email_format_incorrect') }}</span>
                    </div>
                  </div>
                          </div>
                
                <!-- 登录密码输入 -->
                <div class="label password-label">
                  <div class="label-header">
                    <icon-lock class="label-icon"/>
                    <p class="label-text">{{ $t('login.password') }}</p>
                      </div>
                  <div class="input-wrapper">
                    <a-input-password 
                      class="input password-input" 
                      :placeholder="$t('login.enter_password')" 
                      v-model="password"
                      @change="checkPassword">
                      <template #prefix>
                        <icon-lock class="input-prefix-icon"/>
                    </template>
                    </a-input-password>
                    <div class="input-status" :class="{ 'show': password, 'valid': password && !is_password, 'invalid': password && is_password }">
                      <icon-check-circle v-if="password && !is_password" class="status-icon valid"/>
                      <icon-close-circle v-if="password && is_password" class="status-icon invalid"/>
                                          <span v-if="password && !is_password" class="status-text valid">{{ $t('login.password_format_correct') }}</span>
                    <span v-if="password && is_password" class="status-text invalid">{{ $t('login.password_format_incorrect') }}</span>
                    </div>
            </div>
            </div>
            </div>
            </div>
          </a-tab-pane>
        </a-tabs>
        
        <a-button 
          :loading="loading" 
          class="loginBtn" 
          @click="login"
          :disabled="!email || !password || is_email || is_password">
          {{loginText}}
        </a-button>
        
        <div class="row">
          <div class="item" @click="toRegister()">
                                <span class="color-black">{{ $t('login.no_account') }}<strong class="color-primary">{{ $t('login.register') }}</strong></span>
          </div>
          <div class="item" @click="toReset()">
                            <span class="color-primary">{{ $t('login.forgot_password') }}</span>
          </div>
        </div>
      </div>
    </a-layout-content>
  </a-layout>
</template>
<script>
import service from './service';
export default service;
// import PageNav from "@/components/PageNav/PageNav.vue";
// import common from '@/common/api/common.js';
// import country from '../../common/area';
// import util from "@/common/util";
// import {mapState, mapMutations} from 'vuex';
// import {Notification} from '@arco-design/web-vue';
//
// export default {
//   name: "LoginView",
//   components: {PageNav},
//   data() {
//     return {
//       country: country.countryList,
//       code: '+86',
//       showCountry: false,
//       phone: '',
//       is_phone: false,
//       email: '',
//       is_email: false,
//       password: '',
//       is_password: false,
//       type: 1
//     }
//   },
//   mounted() {
//     let code = this.$route.query['invaite-code']
//     if (code) {
//       this.$util.setCache('invaite-code', code);
//     }
//   },
//   computed: {
//     ...mapState(['config', 'userTheme'])
//   },
//   methods: {
//     ...mapMutations(['userLogin']),
//     loginType(k) {
//       this.type = k
//     },
//     checkPhone() {
//       this.is_phone = !util.validatePhoneNumber(this.code + this.phone)
//       if (this.is_phone == false) {
//         this.handleNotice(this.$t('login.t10'));
//       }
//     },
//     checkEmail() {
//       this.is_email = !util.validateEmail(this.email)
//       if (this.is_email == false) {
//         this.handleNotice(this.$t('login.t11'));
//       }
//     },
//     checkPassword() {
//       let len = this.password.length
//       this.is_password = !(len >= 8 && len <= 64)
//       if (this.is_password == false) {
//         this.handleNotice(this.$t('login.t12'));
//       }
//     },
//     login() {
//       const loginInfo = {
//         phone: this.phone,
//         email: this.email,
//         password: this.password,
//         type: this.type
//       };
//       if (this.type == 1) {
//         if (!this.phone || !this.password) {
//           return;
//         }
//         loginInfo['phone'] = this.phone;
//         loginInfo['code'] = this.code.replace('+', '');
//         util.setCache('login_phone', this.phone);
//       } else {
//         if (!this.email || !this.password) {
//           return;
//         }
//         loginInfo['email'] = this.email;
//         util.setCache('login_email', this.email);
//       }
//
//       common.login(loginInfo).then((res) => {
//         if (res.success) {
//           this.userLogin(res.data);
//           this.$message.info({
//             content: this.$t('login.t31'),
//             duration: 2000,
//             showIcon: false
//           })
//           this.$router.push('/HomeView/assets')
//         } else {
//           this.$message.info({
//             content: res.message,
//             showIcon: false
//           })
//         }
//       });
//     },
//     toRegister() {
//       this.$router.push("/register");
//     },
//     toReset() {
//       this.$router.push("/resetPass");
//     },
//     countryOk(e) {
//       this.code = e.dialingCode
//     },
//     handleNotice(content) {
//       Notification.error({
//         title: '提示',
//         content: content,
//         closable: true,
//         duration: 2000
//       })
//     },
//     filterCountry(e) {
//       this.country = country.countryList.filter((item) => {
//         return item.dialingCode.includes(e) || item.enName.includes(e) || item.cnName.includes(e);
//       });
//     },
//     resetCountry() {
//       this.country = country.countryList;
//     },
//   }
// }
</script>


<style>
.basic {
  padding: 10px;
  width: 400px;
  background-color: #1d2126;
  border-radius: 4px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
}

.country-item {
  display: flex;
  justify-content: space-between;
  width: 380px;
  height: 44px;
  color: #fff;
  padding: 10px 0;
}
</style>